import {} from "native-base";
import {
  Button,
  Center,
  FormControl,
  HStack,
  Input,
  Select,
  View,
  VStack,
  Box,
  Text,
  Spinner,
  Pressable,
} from "native-base";
import { Tabs, Tab, Box as MuiBox, Typography } from "@mui/material";
import { isLoaded, useFirestoreConnect } from "react-redux-firebase";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { getFirestore } from "redux-firestore";
import { DeleteTables, SetTableBiz } from "../Redux/actions";
import AddTableModal from "../components/AddTableModal";
import TableDetailsModal from "../components/TableDetailsModel";
import { useHistory } from "react-router-dom";
import WindowQrComponent from "../components/assetComponent/windowsQr";
import {
  SERVICE_QR_ID,
  TABLE_QR_ID,
  WINDOW_QR_ID,
  downloadQr,
} from "../utils/qr_util";
import ServiceDeskQrComponent from "../components/assetComponent/servicedeskQr";
import TableQRComponent from "../components/assetComponent/tableQr";
import FloorPlanEditor from "../components/floor-plan/FloorPlanEditor";
import StaffManagement from "../components/StaffManagement";
import useStaffRole from "../hooks/useStaffRole";

const BussinessPage = (props) => {
  useEffect(() => { document.title = "Business | Piatto"; }, []);
  const id = props.match.params.id;
  const history = useHistory();

  const [Tables, setTables] = React.useState([]);
  const [Categories, setCategories] = React.useState([]);
  const firestore = getFirestore();
  const [AddTable, setAddTable] = React.useState(false);
  const [detailTable, setDetailTable] = React.useState();
  const [activeTab, setActiveTab] = React.useState(0);
  const { role, isOwner, isManager, canManageTables, canEditFloorPlan, canViewOnly } = useStaffRole(id);

  React.useEffect(() => {
    if (id) {
      const unsubscribe = firestore
        .collection("Business")
        .doc(`${id}`)
        .collection("Tables")
        .onSnapshot((snapshot) => {
          //
          const tables = [];
          const categories = []; // for seperate list

          snapshot.docs.forEach((doc) => {
            let data = { ...doc.data(), id: doc.id };

            if (data["category"]) {
              let tableCategory = tables.find(
                (t) => t["category"] === data["category"]
              );
              if (tableCategory) {
                tableCategory["tables"].push(data);
              } else {
                // tabale catefory was not made
                tables.push({
                  category: data["category"],
                  tables: [data],
                });
                categories.push(data["category"]);
              }
            }
          });
          setTables(tables);
          setCategories(categories);
          setAddTable(false);
        });
      return () => {
        unsubscribe();
      };
    }
  }, [id]);

  useFirestoreConnect([
    {
      collection: "Business",
      doc: id,
      storeAs: "manageBusiness",
    },
  ]);
  const SingleBusiness = useSelector(
    ({ firestore: { data } }) => data.manageBusiness
  );

  const handleAddTables = () => {
    setAddTable(true);
  };

  const handleDownloadQr = (table) => {
    downloadQr(`${TABLE_QR_ID}-${table["tableNo"]}`);
  };

  const handleReceptionQr = () => {
    downloadQr(SERVICE_QR_ID);
  };
  const handleWindowQr = () => {
    downloadQr(WINDOW_QR_ID);
  };

  const handleEditPage = () => {
    history.push(`/editBusiness/${id}`);
  };

  const addEditTableToFB = (tables) => {
    SetTableBiz(id, tables);
  };
  const addTablesNumber = (numbers, category, extraFields = {}) => {
    let tables = [];
    for (let tb of numbers) {
      tables.push({
        tableNo: tb,
        category: category,
        tableType: extraFields.tableType || 'standard',
        seatCount: extraFields.seatCount || 4,
        wheelchairAccessible: extraFields.wheelchairAccessible !== false,
        zone: extraFields.zone || 'inside',
        floor: extraFields.floor || 'ground',
        elevated: extraFields.elevated || false,
      });
    }
    addEditTableToFB(tables);
    setAddTable(false);
  };

  const saveEditTable = (table) => {
    addEditTableToFB([table]);
    setDetailTable(undefined);
  };

  const deleteTables = (tables) => {
    DeleteTables(id, tables);
  };

  const tablesComponent = (tables, category) => {
    return (
      <Box>
        <Text>{category}</Text>
        <Box flexDir={"row"} flexWrap={"wrap"} m={2}>
          {(tables.tables ?? []).map((t) => {
            return (
              <Pressable
                key={t.tableNo}
                onPress={() => {
                  setDetailTable(t);
                }}
                mb={2}
              >
                <Center
                  height={"13vh"}
                  width={"13vh"}
                  borderWidth={2}
                  borderColor={"green.500"}
                >
                  <Text>TABLE {t.tableNo}</Text>
                </Center>
              </Pressable>
            );
          })}
        </Box>
      </Box>
    );
  };

  {
    const bizName = SingleBusiness?.bizName || "";
    return (
      <VStack
        role="main"
        flex="1"
        _light={{ bg: "white" }}
        _dark={{ bg: "coolGray.800" }}
        space="3"
        justifyContent="space-between"
      >
        <Center w={"100%"}>
          <Text color={"white"} position={"absolute"} zIndex={99999} top={-50}>
            {bizName}
          </Text>
          <Button mb={1} onPress={() => history.goBack()} w={"100%"}>
            Back to Order Page
          </Button>

          <VStack maxW="3/4" mt={10} width="100%" alignItems="flex-start">
            {!canViewOnly && (
              <HStack alignItems="center" mt={10}  gap={2}>
                <Text fontSize="lg">Edit Business Details</Text>
                <Button
                  size="xs"
                  colorScheme="blue"
                  marginLeft={13}
                  onPress={handleEditPage}
                >
                  Edit Business Details
                </Button>
              </HStack>
            )}

            <MuiBox
              sx={{
                width: '100%',
                mt: 3,
                p: 2,
                borderRadius: 2,
                backgroundColor: '#523384',
                color: '#fff',
              }}
              aria-label="AI Generated Accessibility Recommendations"
            >
              <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#fff', mb: 1 }}>
                AI Generated Accessibility Recommendations
              </Typography>
              {SingleBusiness?.aiAccessNarrative ? (
                <Typography variant="body1" sx={{ color: '#fff' }}>
                  {SingleBusiness.aiAccessNarrative}
                </Typography>
              ) : (
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                  No AI Generated recommendations yet
                </Typography>
              )}
              {SingleBusiness?.aiSummary && (
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.85)', mt: 1 }}>
                  {SingleBusiness.aiSummary}
                </Typography>
              )}
            </MuiBox>

            <MuiBox sx={{ mt: 2, mb: 2 }}>
              <Typography variant="body2" color="text.secondary">
                Use the tabs below to 1. Add TABLE records and print QR codes for each table, 2. Use the FLOOR PLAN EDITOR to share a floor plan of your venue so we can help people to plan, potentially reserve a table to their liking and know what to expect (many people with disabilities really benefit from knowing exactly what to expect); 3. GENERAL QR'S will allow you to print a new Window Sticker or Reception Sign, both of which have QR codes to allow Piatto users to engage with your venue's menu in a 100% digitally accessible way; and 4. STAFF to manage who has access to this venue — add staff members, assign roles, and control permissions.
              </Typography>
            </MuiBox>

            <MuiBox sx={{ width: '100%', mt: 3 }}>
              <Tabs value={activeTab} onChange={(_, v) => setActiveTab(v)} sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tab label="Tables" />
                <Tab label="Floor Plan Editor" />
                <Tab label="GENERAL QR's" />
                <Tab label="Staff" />
              </Tabs>

              {/* Tables tab */}
              {activeTab === 0 && (
                <MuiBox sx={{ pt: 2 }}>
                  <HStack alignItems="center" mb={6} gap={2}>
                    <Text fontSize="lg">Tables</Text>
                    {canManageTables && (
                      <Button size="xs" onPress={handleAddTables} marginLeft={127}>
                        Add +
                      </Button>
                    )}
                  </HStack>
                  {Tables.map((t) => (
                    <React.Fragment key={t["category"]}>
                      {tablesComponent(t, t["category"])}
                    </React.Fragment>
                  ))}
                </MuiBox>
              )}

              {/* Floor Plan Editor tab */}
              {activeTab === 1 && (
                <MuiBox sx={{ pt: 2 }}>
                  {canEditFloorPlan ? (
                    <FloorPlanEditor bizId={id} />
                  ) : (
                    <>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        You have view-only access to the floor plan. Contact an Owner or Manager to make changes.
                      </Typography>
                      <FloorPlanEditor bizId={id} readOnly />
                    </>
                  )}
                </MuiBox>
              )}

              {/* General QRs tab */}
              {activeTab === 2 && (
                <MuiBox sx={{ pt: 2 }}>
                  <HStack alignItems="center" gap={2}>
                    <Text fontSize="lg">General QRs</Text>
                    <Button size="xs" colorScheme="green" onPress={handleReceptionQr} marginLeft={79}>
                      Reception QR
                    </Button>
                    <Button size="xs" colorScheme="orange" onPress={handleWindowQr} marginLeft={5}>
                      Window QR
                    </Button>
                  </HStack>
                </MuiBox>
              )}

              {/* Staff tab */}
              {activeTab === 3 && (
                <MuiBox sx={{ pt: 2 }}>
                  <StaffManagement bizId={id} />
                </MuiBox>
              )}
            </MuiBox>
          </VStack>
        </Center>
        <AddTableModal
          opened={AddTable}
          closeHandler={() => {
            setAddTable(false);
          }}
          categories={Categories}
          onAdd={addTablesNumber}
        />
        <TableDetailsModal
          bizId={id}
          bizName={bizName}
          table={detailTable}
          closeHandler={() => {
            setDetailTable(undefined);
          }}
          categories={Categories}
          onSave={canManageTables ? saveEditTable : undefined}
          downloadQR={(table) => {
            handleDownloadQr(table);
          }}
          onDelete={canManageTables ? (table) => {
            deleteTables([table]);
            setDetailTable(undefined);
          } : undefined}
        />
        <WindowQrComponent bizId={id} />
        <ServiceDeskQrComponent bizId={id} />
      </VStack>
    );
  }
};

export default BussinessPage;
